import React, { memo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const TemplatePage = memo(({ data = {}, picture, selected = false }) => {
  const { name, image } = data;
  const { isDark } = useSelector((state) => state.theme);

  return (
    <div
      className={`report-template border border-1 rounded p-2 overflow-hidden h-100`}
      style={{ background: selected ? "#f45b41" : "" }}
    >
      <div className="report-template_graph">
        {picture ? <img src={picture} alt="template" /> : image?.url ? <img src={image?.url} alt="template" /> : ""}
      </div>
      <h6 className={`report-template_name text-capitalize ${selected || isDark ? "text-white" : "text-black"}`}>
        {name}
      </h6>
    </div>
  );
});

export default TemplatePage;

TemplatePage.displayName = "TemplatePage";

TemplatePage.propTypes = {
  data: PropTypes.object,
  picture: PropTypes.string,
  selected: PropTypes.bool,
};
